import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';

const ARAgingReportRow = ({ rowData, id }) => {
  const { serviceType, totalAmount, overDue, unDue, day30, day60, day90, day120, above120 } =
    rowData;
  return (
    <tr key={id} className="table-body-tr">
      <td>{serviceType === 'cemetry' ? 'Cemetery' : serviceType}</td>
      <td>{getPrice(totalAmount) || '-'}</td>
      <td>{getPrice(unDue) || '-'}</td>
      <td>{getPrice(overDue) || '-'}</td>
      <td>{getPrice(day30) || '-'}</td>
      <td>{getPrice(day60) || '-'}</td>
      <td>{getPrice(day90) || '-'}</td>
      <td>{getPrice(day120) || '-'}</td>
      <td>{getPrice(above120) || '-'}</td>
    </tr>
  );
};
ARAgingReportRow.propTypes = {
  rowData: PropTypes.shape({
    serviceType: PropTypes.string,
    totalAmount: PropTypes.number,
    overDue: PropTypes.number,
    unDue: PropTypes.number,
    day30: PropTypes.number,
    day60: PropTypes.number,
    day90: PropTypes.number,
    day120: PropTypes.number,
    above120: PropTypes.number,
  }).isRequired,
  id: PropTypes.string.isRequired,
};
export default ARAgingReportRow;
